import { UserAddressesResponseModel } from "../pages/shared/models/api/user-addresses-response.moel";
import { UserAddress } from "../pages/shared/models/user/user-address";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function createAddress(address: UserAddress) {
  const authorizationHeader = configAuthorizationHeader();

  return axiosInstance.post(
    `${API_URL}/addresses/create`,
    serializeValues(address),
    authorizationHeader,
  );
}

async function editAddress(addressId: number, address: any) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/addresses/${addressId}`,
        serializeValues(address),
        authorizationHeader,
      )
      .then((response) => response?.data as UserAddressUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function getMyAddresses(
  page?: number,
): Promise<UserAddressesResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .get(
        `${API_URL}/addresses/my?limit=11&${page ? "page=" + page : ""}`,
        authorizationHeader,
      )
      .then((response) => response?.data as UserAddressesResponseModel);
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      addresses: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getAddresses(
  filter: object,
  limit: number,
  page?: number,
): Promise<UserAddressesResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/addresses${params.size ? `?${params.toString()}` : ""}`,
        filter,
        authorizationHeader,
      )
      .then((response) => response?.data as UserAddressesResponseModel);
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      addresses: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getAddressById(addressId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/addresses/${addressId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function deleteAddressById(addressId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/addresses/${addressId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

function serializeValues(address: UserAddress) {
  const addressClone: { [key: string]: any } = JSON.parse(
    JSON.stringify(address),
  );

  if (addressClone.country) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addressClone.country = addressClone.country.countryId;
  }
  if (addressClone.province) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addressClone.province = addressClone.province.provinceId;
  }
  if (addressClone.city) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addressClone.city = addressClone.city.cityId;
  }
  if (addressClone.region) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addressClone.region = addressClone.region.regionId;
  }
  delete addressClone.addressId;

  return addressClone;
}

export default {
  createAddress,
  editAddress,
  getMyAddresses,
  getAddresses,
  getAddressById,
  deleteAddressById,
};

export interface UserAddressUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
